import { Logo } from "./Logo"

export function Navigation() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#111820]/96 backdrop-blur-xl border-b border-white/[0.07]">
      <div className="mx-auto px-8 lg:px-12 h-[68px] flex items-center justify-between max-w-[1400px]">
        <a href="#">
          <Logo />
        </a>
        <div className="hidden md:flex items-center gap-9">
          <a
            href="#features"
            className="text-[13px] font-medium tracking-[0.06em] uppercase text-white/65 hover:text-white transition-colors"
          >
            Features
          </a>
          <a
            href="#about"
            className="text-[13px] font-medium tracking-[0.06em] uppercase text-white/65 hover:text-white transition-colors"
          >
            About
          </a>
          <a
            href="#contact"
            className="px-5 py-[9px] bg-[#2E7D4F] hover:bg-[#3B9B63] text-white rounded text-[12px] font-medium tracking-[0.08em] uppercase transition-colors"
          >
            Contact
          </a>
          {/* <a href={loginUrl} className="px-5 py-[9px] border border-[#3B9B63]/40 hover:bg-[#3B9B63]/10 text-[#3B9B63] rounded text-[12px] font-medium tracking-[0.08em] uppercase transition-colors">
            Login
          </a> */}
        </div>
      </div>
    </nav>
  )
}
